import { Typography } from '@mui/material';
import { Action, DataTable } from 'modules/jobs/components/DataTable';
import { useEffect, useState } from 'react';
import classes from './BaseJobCandidatesScreen.module.css';
import CircularProgress from '@mui/material/CircularProgress';
import { Candidate } from 'modules/candidate/services/candidate';
import { HeadCell } from 'modules/jobs/components/interfaces';


export interface GridRow {
  raw: Candidate;
  name: string;
  location: string;
  startDate: string;
  endDate: string;
  minHourlyRate: string;
}


type Props = {
  candidates: Candidate[];
  onClick: (candidate: Candidate) => void;
  actions?: Action<GridRow>[];
}


const headCells: readonly HeadCell<GridRow, keyof GridRow>[] = [
  {
    id: 'name',
    numeric: false,
    label: 'Name',
    sortable: true,
  },
  {
    id: 'location',
    numeric: true,
    label: 'Location',
    sortable: true,
    sortValue: row => row.raw.homeAddress.city
  },
  {
    id: 'startDate',
    numeric: true,
    label: 'Start Date',
    sortable: true,
    sortValue: row => row.raw.firstDay.toMillis()
  },
  {
    id: 'endDate',
    numeric: true,
    label: 'End Date',
    sortable: true,
    sortValue: row => row.raw.lastDay?.toMillis() ?? Number.MAX_SAFE_INTEGER
  },
  {
    id: 'minHourlyRate',
    numeric: true,
    label: 'Min. Hourly Rate',
    sortValue: row => row.raw.desiredWage
  },
];


export function BaseJobCandidatesScreen({ candidates, onClick, actions }: Props) {
  const [rows, setRows] = useState<GridRow[]>([]);

  function handleCandidateClick({ raw: candidate }: GridRow) {
    onClick(candidate);
  }

  // fill rows for the table
  useEffect(() => {
    candidates && setRows(candidates
      .filter(c => c.isOnboarded)
      .map(c => ({
          raw: c,
          name: c.firstName + ' ' + c.lastName,
          location: c.homeAddress.city + ', ' + c.homeAddress.state,
          startDate: c.firstDay.toDate().toLocaleDateString('en-US'),
          endDate: c.lastDay?.toDate().toLocaleDateString('en-US') ?? 'N/A',
          minHourlyRate: '$' + c.desiredWage + '/hr',
        })
      )
    )}, [candidates]);

  return(
    <div className={classes.container}>

      <div className={classes.header}>
        <Typography variant='h4' sx={{color: 'mainBackground.contrastText'}}>Available Candidates</Typography>
        { !candidates && <CircularProgress className={classes.progress} size={30}/> }
      </div>

      <DataTable
        actions={actions}
        data={rows}
        headCells={headCells}
        initialOrderBy='startDate'
        keyField={row => row.name}
        onRowClick={handleCandidateClick}
      />
    </div>
  );
}
